import { FC } from 'react';
import { AddRounded } from '@mui/icons-material';
import { Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import './TeamEmptyHome.scss';

interface TeamEmptyHomeProps {
  teamInitials: string;
  resolvedTeamName: string;
  onOpenInviteModal: () => void;
}

const renderBlob = (className: string) => <span aria-hidden="true" className={className} />;

const TeamEmptyHome: FC<TeamEmptyHomeProps> = ({
  teamInitials,
  resolvedTeamName,
  onOpenInviteModal,
}) => {
  const { t } = useTranslation();

  return (
    <main className="team-empty-home" aria-live="polite">
      {renderBlob('team-blob team-blob--empty-left')}
      {renderBlob('team-blob team-blob--empty-right')}
      <div className="team-empty-home__content">
        <div className="team-page__team-avatar team-page__team-avatar--large">{teamInitials}</div>
        <Typography variant="h2" component="h1" className="team-page__title">
          {t('team.empty.title', { teamName: resolvedTeamName })}
        </Typography>
        <Typography
          variant="body2"
          component="p"
          className="team-page__subtitle team-page__subtitle--empty"
        >
          {t('team.empty.description')}
        </Typography>
        <div className="team-page__actions team-page__actions--center">
          <Button
            type="button"
            variant="contained"
            color="primary"
            className="team-page__button team-page__button--primary"
            startIcon={<AddRounded />}
            onClick={onOpenInviteModal}
          >
            <Typography variant="body1" component="span">
              {t('team.common.inviteMembers')}
            </Typography>
          </Button>
        </div>
      </div>
    </main>
  );
};

export default TeamEmptyHome;
